import {Component} from '@angular/core';
import {ParksService} from '@app/app/shared/services/parks.service';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {Router} from '@angular/router';

@Component({
  templateUrl: './nav.html',
  selector: 'main-nav',
  styles: [``]
})
export class NavComponent {
  public filters = [
    {label: 'In alarms', value: 'inAlarms'},
    {label: 'On', value: 'on'},
    {label: 'Off', value: 'off'},
    {label: 'Offline', value: 'offline'}
  ];

  public routes = [];

  constructor(private parksService: ParksService, private router: Router, private auth: AuthenticationService) {
    if (this.auth.userRole() === 'admin' || this.auth.userRole() === 'client' || this.auth.userRole() === 'employee') {
      this.routes.push({path: '/dashboard', src: 'assets/img/icon_dashboard.svg', label: 'Dashboard'});

      if (this.auth.isPro() && this.auth.isPremium()) {
        this.routes.push({path: '/alarms', src: 'assets/img/icon_alarms_tasks.svg', label: 'All alarms / tasks'});
        this.routes.push({path: '/reports', src: 'assets/img/icon_reports.svg', label: 'Reports'});
      }
    }

    if (this.auth.userRole() === 'admin') {
      this.routes.push({path: '/admins', src: 'assets/img/icon_clients.svg', label: 'User/ctrl management'});
    }

    if (this.auth.userRole() === 'manufacturer') {
      this.routes.push({path: '/clients', src: 'assets/img/icon_clients.svg', label: 'User/ctrl management'});
    }

    if (this.auth.userRole() === 'client') {
      this.routes.push({path: '/employees', src: 'assets/img/icon_clients.svg', label: 'User management'});
    }

    this.routes.push({path: '/level-of-access', src: 'assets/img/icon_access.png', label: 'Level of access'});
  }

  public search($event) {
    this.parksService.source.next($event);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/components/nav/nav.component.ts